export default __webpack_public_path__ + "static/media/ship2.bbd6bd4e.png";